import axios from 'axios';

import * as utils from '../utils/utils.js';

export const deleteParticipant = async (participant_id) => {
    const session_url = utils.backendUrl() + '/participant';

    try {
        const response = await axios.delete(session_url, {
            data: {
                participant_id: participant_id,
            },
            headers: {
                'Content-Type': 'application/json',
            },
            withCredentials: true,
        });
        return response.data.response;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};
